import React, { FC, ReactNode } from 'react';
import styled, { AnyStyledComponent, CSSObject } from 'styled-components';

import RawDropdown, {
  Option as DropdownOption,
  Props as DropdownProps,
} from '^/components/atoms/Dropdown/1';
import palette from '^/constants/palette';
import { VolumeContent } from '^/types';
import Text from './text';
import { useL10n } from '^/hooks/useL10n';

const Root = styled.div({
  fontSize: '13px',
  fontWeight: 500,
  minWidth: '200px',
  color: palette.textBlack.toString(),
});
Root.displayName = 'VolumeSelectDropdown';

interface DropdownStyleProps {
  dropdownStyle?: CSSObject;
}
const Dropdown = styled(RawDropdown as AnyStyledComponent)<DropdownProps & DropdownStyleProps>(
  {
    display: 'inline-block',

    width: '100%',
  },
  ({ dropdownStyle }) => (dropdownStyle ? dropdownStyle : {})
);
Dropdown.displayName = 'Dropdown';

const NotificationWrapper = styled.div({
  marginTop: '10px',
  fontSize: '13px',
  lineHeight: 1,
  fontWeight: 'normal',
  color: palette.error.toString(),
});

export interface Props {
  value?: string;
  isError?: boolean;
  options?: DropdownOption[];
  dropdownButtonStyle?: CSSObject;
  onSelect(value: VolumeContent['id']): void;
}

const VolumeSelectDropDown: FC<Props> = ({
  value,
  isError,
  options,
  onSelect,
  dropdownButtonStyle,
}) => {
  const [l10n] = useL10n();
  const dropdownMainButtonStyle: CSSObject = {
    color: palette.textGray.toString(),
    border: `1px solid ${isError ? palette.UploadPopup.error.toString() : 'D9D9D9'}`,
  };

  const handleDropdownClick: (option: DropdownOption, index: number) => void = (
    option: DropdownOption
  ) => {
    onSelect(option.value);
  };

  const selectRequiredNotification: ReactNode = isError ? (
    <NotificationWrapper>{l10n(Text.volume.error)}</NotificationWrapper>
  ) : undefined;

  const mainButtonStyle: CSSObject = {
    ...dropdownMainButtonStyle,
    ...dropdownButtonStyle,
  };

  const dropdownOptions: DropdownOption[] = options ?? [];

  return (
    <Root>
      <Dropdown
        zIndex={1}
        value={value}
        key={value}
        isSearchEnable={true}
        options={dropdownOptions}
        onClick={handleDropdownClick}
        mainButtonStyle={mainButtonStyle}
        placeHolder={l10n(Text.volume.placeholder)}
      />
      {selectRequiredNotification}
    </Root>
  );
};

export default VolumeSelectDropDown;
